import {FlexOfferPrice, FlexOfferPriceType, FLEX_OFFER_PRICE_TYPE, EntryUnit, Money} from "../types";
import { FlexOfferServiceError } from "../Errors/FlexOfferServiceError";
import type {WidgetFlexOfferPriceResponse} from "@bookingkit/api-v4/models/widget-flex-offer-price-response";
import type {WidgetMoneyResponse} from "@bookingkit/api-v4/models/widget-money-response";
import type {WidgetEntryUnitResponse} from "@bookingkit/api-v4/models/widget-entry-unit-response";


const mapPrice = (price?: WidgetMoneyResponse): Money => {
    if (price === undefined) {
        throw FlexOfferServiceError.fromMissingProperty('price', 'Money', price);
    }
    const {value, currency} = price;

    if (value === undefined) {
        throw FlexOfferServiceError.fromMissingProperty('price.value', 'number', value);
    }

    if (currency === undefined) {
        throw FlexOfferServiceError.fromMissingProperty('price.currency', 'string', currency);
    }

    return {
        amount: value,
        currency,
    };
};

const mapEntryUnits = (entryUnits?: WidgetEntryUnitResponse[]): EntryUnit[] => {
    if (!entryUnits || entryUnits.length === 0) {
        throw FlexOfferServiceError.fromMissingProperty('entryUnits', 'EntryUnit[]', entryUnits);
    }

    return entryUnits.map((unit, index) => {
        if (unit.type === undefined) {
            throw FlexOfferServiceError.fromMissingProperty(`entryUnits[${index}].type`, 'string', unit.type);
        }

        return {
            type: unit.type,
        };
    });
};

export const mapFlexOfferPrices = (flexOffer:WidgetFlexOfferPriceResponse):FlexOfferPrice => {
    const {id, title, price, entry_units, type} = flexOffer;

    if (id === undefined) {
        throw FlexOfferServiceError.fromMissingProperty('id', 'string', id);
    }

    if (title === undefined) {
        throw FlexOfferServiceError.fromMissingProperty('title', 'string', title);
    }

    if (type === undefined) {
        throw FlexOfferServiceError.fromMissingProperty('type', 'FlexOfferPriceType', type);
    }

    if (!Object.values(FLEX_OFFER_PRICE_TYPE).includes(type as FlexOfferPriceType)) {
        throw FlexOfferServiceError.fromInvalidProperty('type', type);
    }
    return {
        id,
        title,
        price: mapPrice(price),
        entryUnits: mapEntryUnits(entry_units),
        type: type,
    };
};
